/* cf-enduro-hinge-panel.js - Click Fencing, 2026-09-14 (coated gate added the same evening)
 *
 * AN ENDUROSHIELD GLASS JOB ORDERED AN UNCOATED HINGE PANEL - AND AN UNCOATED GATE.
 *
 * Found from a real enquiry (Paul Dobson, 14 Sep 2026): every glass line on his quote was
 * "EnduroShield Coated" except "1800mm Gate Hinge Panel $240.89". Measured on the live
 * theme 141677789278 the same evening:
 *
 *   EnduroShield + soft close + 6000mm + 900 gate glass-to-glass
 *     "1600mm Gate Hinge Panel"  $214.26   sku 48219  variant 42018463875166
 *
 * 48219 / 42018463875166 is the PLAIN hinge panel (glass-pool-fence-hinge-panel). The cart
 * (cf-real-line-items.js) resolves a line by variantId first, so the coated job would have
 * ordered uncoated glass for the hinge panel. The price shown matched no product either:
 *   ullc-catalogue-fix.js hingeUnitPrice() = plain hinge price x (coated / plain panel price)
 *   1800: $202.69 x ($207.03 / $174.20) = $240.89     (real coated part: $223.72)
 *   1600: $180.29 x ($195.53 / $164.52) = $214.26     (real coated part: $198.86)
 * Its comment says "James Glen has no Enduroshield hinge panel". That is wrong: JG
 * 49721-49733 "CLEAR TOUGHENED HINGE PANEL ENDUROSHIELD 12X<w>X1200" exist, and the store
 * sells them on enduroshield-coated-toughened-glass-hinge-panel (600-1800, 13 widths).
 * The sku itself is stamped later by updateQuoteDisplay() in ullc-calc.js (~14816) from
 * hingeStandardPanel, which only ever holds the plain product.
 *
 * THE GATE (added 2026-09-14, Pete: "if paul chose enduroshield coating, his gates should be
 * endurosheild coated. we do sell them for sure!"). The gate leaf is 8mm clear on Polaris
 * S155 hinges by design (29 Jul 2026). James Glen DOES make that gate coated - 49602/49603/
 * 49604, 8x800/850/900x1200 - it simply was not on the store until 14 Sep 2026, when it was
 * created as enduroshield-coated-toughened-frameless-glass-pool-gate-panel-8mm. On an
 * EnduroShield section the "Gate Panel <w> x 1200mm" line now becomes that coated 8mm gate.
 * Still 8mm, still S155 hinges, still the same latch - only the coating changes.
 *
 * WHAT THIS DOES
 * On an EnduroShield section only:
 *   "<w>mm Gate Hinge Panel"   -> coated STANDARD hinge panel 4972x, "..., EnduroShield Coated"
 *   "Gate Panel <w> x 1200mm"  -> coated 8mm gate 49602-49604,       "..., EnduroShield Coated"
 * Each takes the part's sku, its variant id (CF_VARIANT) and its live price (CF_PRICE), and
 * the section subtotal moves by the price difference. The later stamper skips a line that
 * already has a sku. Keyed on SKU, never on a hard-coded variant id.
 *
 * Why the STANDARD coated hinge panel and not the soft-close one (49734-49746): those are
 * "S125 POLARIS HINGE PANEL ENDURO", cut for S125 hinges. The calculator fits Polaris S155 (or
 * spring) hinges and already uses the standard hinge panel for both - this only adds the
 * coating the customer chose. For the same reason the 12mm coated gates 49605-49607 (S125
 * panels) are NOT used.
 *
 * SAFETY
 * - Plain-glass sections: untouched, byte for byte.
 * - Width not in the map, or CF_PRICE / CF_VARIANT has no such sku yet: the line is left
 *   exactly as the calculator built it - the clear part - and cf-enduro-label.js names it
 *   "Standard Clear (Uncoated)", because that is what would be ordered. Never labelled
 *   coated while ordering clear.
 * - Idempotent: a line already labelled EnduroShield is skipped.
 * - Every step in try/catch; a display or pricing correction must never break a quote.
 * - cf-enduro-label.js appends coating names and waits for this file's flag, because the
 *   regexes below are anchored at the end of the name.
 */
(function () {
  'use strict';

  var TAG = '[cf-enduro-hinge-panel]';
  var FLAG = '__cfEnduroHingePanelPatched';
  var LABEL = ', EnduroShield Coated';

  /* JG / Shopify sku by width - enduroshield-coated-toughened-glass-hinge-panel, read live
     from /products.json 2026-09-14 12:42 UTC. */
  var SKU_BY_WIDTH = {
    600: '49721', 700: '49722', 800: '49723', 900: '49724', 1000: '49725',
    1100: '49726', 1200: '49727', 1300: '49728', 1400: '49729', 1500: '49730',
    1600: '49731', 1700: '49732', 1800: '49733'
  };

  /* JG 8mm EnduroShield coated gates - enduroshield-coated-toughened-frameless-glass-pool-
     gate-panel-8mm (product 7770567639134, created 2026-09-14). */
  var GATE_SKU_BY_WIDTH = { 800: '49602', 850: '49603', 900: '49604' };

  var HINGE_RE = /^(\d+)mm Gate Hinge Panel\s*$/;
  var GATE_RE  = /^Gate Panel (\d+) x 1200mm\s*$/;

  function isEnduro(self, section) {
    try {
      if (typeof self.resolveSectionFinish === 'function') {
        return !!self.resolveSectionFinish(section).enduroShield;
      }
    } catch (e) {}
    return !!(section && section.enduroShield);
  }

  function coatedPart(map, width) {
    var sku = map[width];
    if (!sku) return null;
    var cents = null, vid = null;
    try { if (typeof window.CF_PRICE === 'function') cents = window.CF_PRICE(sku); } catch (e) {}
    try { if (typeof window.CF_VARIANT === 'function') vid = window.CF_VARIANT(sku); } catch (e) {}
    if ((!cents || !vid) && window.CF_SKU_MAP && window.CF_SKU_MAP[sku]) {
      cents = cents || window.CF_SKU_MAP[sku].cents;
      vid = vid || window.CF_SKU_MAP[sku].id;
    }
    cents = Number(cents);
    if (!(cents > 0) || !vid) return null;
    return { sku: sku, id: Number(vid), price: Math.round(cents) / 100 };
  }

  function correct(self, section, quote) {
    if (!quote || !Array.isArray(quote.breakdown) || !isEnduro(self, section)) return;
    var delta = 0;
    quote.breakdown.forEach(function (line) {
      try {
        if (!line || typeof line.item !== 'string') return;
        if (/enduroshield/i.test(line.item)) return;                 // already done
        var part = null, name = null, m;
        if ((m = line.item.match(HINGE_RE))) {
          part = coatedPart(SKU_BY_WIDTH, Number(m[1]));
          name = m[1] + 'mm Gate Hinge Panel' + LABEL;
        } else if ((m = line.item.match(GATE_RE))) {
          part = coatedPart(GATE_SKU_BY_WIDTH, Number(m[1]));
          name = 'Gate Panel ' + m[1] + ' x 1200mm' + LABEL;
        }
        if (!part) return;                                            // leave as built
        var qty = Number(line.quantity) || 1;
        var was = Number(line.totalPrice);
        if (!isFinite(was)) was = (Number(line.unitPrice) || 0) * qty;
        line.item = name;
        line.unitPrice = part.price;
        line.totalPrice = Math.round(part.price * qty * 100) / 100;
        line.variantId = part.id;
        line.sku = part.sku;
        delta += line.totalPrice - was;
      } catch (e) { console.warn(TAG, 'line', e); }
    });
    if (delta && typeof quote.subtotal === 'number') {
      quote.subtotal = Math.round((quote.subtotal + delta) * 100) / 100;
    }
  }

  function install(gc) {
    var proto = Object.getPrototypeOf(gc);
    if (!proto || typeof proto._calcSectionQuote !== 'function') return false;
    if (proto[FLAG]) return true;
    var orig = proto._calcSectionQuote;
    proto._calcSectionQuote = function (sectionNum, section, calculation) {
      var quote = orig.apply(this, arguments);
      try { correct(this, section, quote); } catch (e) { console.warn(TAG, e); }
      return quote;
    };
    proto[FLAG] = true;
    try { console.log(TAG, 'installed (hinge panel + 8mm gate)'); } catch (e) {}
    return true;
  }

  var tries = 0;
  (function wait() {
    var gc = window.glassCalculator || window.glassFencingCalculator;
    try { if (gc && install(gc)) return; } catch (e) { console.warn(TAG, 'install', e); }
    if (++tries > 200) return;
    setTimeout(wait, 100);
  })();
})();
